import { updateTemplateContent } from 'common/api/templates';

import {
    UPDATE_TEMPLATE,
    UPDATE_TEMPLATE_SUCCESS,
    UPDATE_TEMPLATE_FAILURE,
} from '../actionTypes';
import { editTemplateViewActions } from '../reducer';

export default (templateId, data) => (dispatch) =>
    new Promise((resolve, reject) => {
        if (!templateId) return;

        dispatch(editTemplateViewActions[UPDATE_TEMPLATE]());

        updateTemplateContent(
            {
                content: JSON.stringify(data),
            },
            templateId,
        )
            .then((response) => {
                dispatch(editTemplateViewActions[UPDATE_TEMPLATE_SUCCESS]());
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(
                    editTemplateViewActions[UPDATE_TEMPLATE_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
                reject();
            });
    });
